import styled from 'styled-components';

const StyledSelectFilter = styled.div`
  ${(props) =>
    props.fitWidth &&
    `
    min-width: ${props.fitWidth}px;
    max-width: ${props.fitWidth}px;
  `}
`;

export { StyledSelectFilter };
